import { mount } from 'svelte';
import './app.css';
import AppSim from './AppSim.svelte';
import { initSim } from '@sim/store';

const app = mount(AppSim, { target: document.getElementById('app')! });

// Boot the colony sim: load save (or new game) and start the real-time loop.
initSim();

export default app;
